import axios from "axios";

const getDBStatus = (config, setLoading) => {
  setLoading(true);
  axios
    .get(`${config.api}check-db-status`)
    .then(response => {
      setLoading(false);
      if (!response.data) window.location.replace(config.errorContent);
    })
    .catch(error => {
      setLoading(false);
      window.location.replace(config.errorContent);
    });
};

export default {
  checkDBStatus: (config, setLoading) => {
    getDBStatus(config, setLoading);
  },
  setupInterceptors: (config, setLoading) => {
    axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (!error.config.url.includes("check-db-status")) {
          getDBStatus(config, setLoading);
        }
        return Promise.reject(error);
      }
    );
  }
};
